import { useState, useEffect } from 'react'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography,
  Box,
} from '@mui/material'

function DataTable({ data, selectedFields, availableFields }) {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const fieldMap = {
    alkalinity_ppm: { key: 'total_alkalinity_ppm_rolling_avg', label: 'Alkalinity (ppm)', decimals: 1 },
    ph: { key: 'ph', label: 'pH', decimals: 2 },
    temperature: { key: 'temperature_c', label: 'Temperature (°C)', decimals: 1 },
    conductivity: { key: 'conductivity_mscm', label: 'Conductivity (mS/cm)', decimals: 2 }
  }

  const activeFields = Object.keys(selectedFields)
    .filter(k => selectedFields[k] && availableFields[k])

  useEffect(() => {
    setPage(0)
  }, [data])

  if (!data || data.length === 0 || activeFields.length === 0) {
    return null
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const pageData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

  return (
    <Card sx={{ mt: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Data Table
        </Typography>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Timestamp</TableCell>
                {activeFields.map(field => (
                  <TableCell key={field} align="right">
                    {fieldMap[field].label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {pageData.map((row, idx) => (
                <TableRow key={idx} hover>
                  <TableCell>
                    {new Date(row.timestamp).toLocaleString([], {
                      month: 'short',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit'
                    })}
                  </TableCell>
                  {activeFields.map(field => {
                    const fieldInfo = fieldMap[field]
                    const value = row[fieldInfo.key]
                    return (
                      <TableCell key={field} align="right">
                        {value !== undefined && value !== null ? (
                          Number(value).toFixed(fieldInfo.decimals)
                        ) : (
                          <Box component="span" color="text.disabled">—</Box>
                        )}
                      </TableCell>
                    )
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </CardContent>
    </Card>
  )
}

export default DataTable
